import { Platform } from "react-native";
import { navigate } from "./navigationService";
import consts from "../config";

export const ajustarString = (str) => {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.replace(/,/g, ", ");
};

export const encurtarTextoSeNecessario = (texto) => {
  return ajustarString(
    texto
      ?.toLowerCase()
      ?.substring(0, 150)
      ?.concat(texto?.length > 150 ? " [...]" : "")
  );
};

export const textoNumeroDocumentoComSerie = (item) =>
  dadoExiste(item?.numeroDocumentoFiscal) && dadoExiste(item?.serie)
    ? `${item?.numeroDocumentoFiscal}-${item?.serie}`
    : "";

export const getStringEndereco = (item) => {
  let endereco = "";
  endereco += dadoExiste(item?.logradouro)
    ? item?.logradouro
    : "LOGRADOURO NÃO INFORMADO";

  endereco += dadoExiste(item?.numero) ? `, N° ${item?.numero} ` : "";
  endereco += dadoExiste(item?.complemento) ? ` ${item?.complemento}` : "";
  endereco += dadoExiste(item?.bairro) ? ` - ${item?.bairro}` : "";
  endereco += dadoExiste(item?.cep) ? ` ${item?.cep}` : "";
  endereco += dadoExiste(item?.cidade)
    ? ` ${item?.cidade?.toUpperCase()}`
    : " FORTALEZA";

  const estado = item?.uf || item?.estado;
  endereco += "/" + (dadoExiste(estado) ? `${estado?.toUpperCase()}` : "CE");
  return endereco;
};

export const objCheckboxToArray = (obj) => {
  if (!obj) {
    return [];
  }
  return Object.keys(obj)
    .map((key) => (obj[key] ? key : null))
    .filter((e) => !!e);
};

export const getNomeArquivo = (f) => {
  let nome = f?.name || f?.nome;
  const temTipo = nome?.indexOf("-t_") >= 0 && nome?.indexOf("_t-") >= 0;

  if (temTipo) {
    const posicaoInicial = nome?.indexOf("-t_");
    const posicaoFinal = nome?.indexOf("_t-") + 3;
    if (posicaoInicial >= 0 && posicaoFinal >= 0) {
      const tipo = nome?.substring(posicaoInicial, posicaoFinal);
      nome = nome?.replace(tipo, "");
    }
    nome = nome?.replace(/_/g, " ");
  }
  return nome;
};


export const eAplicativo = Platform.OS === "ios" || Platform.OS === "android";

export const redirecionarCaminhoWeb = () => {
  const caminho = !eAplicativo && window.location.href;

  if (caminho) {
    if (caminho?.includes("denuncia/novo")) {
      navigate("CadastrarDenuncia");
      return null;
    }

    if (caminho?.includes("denuncia/buscar")) {
      navigate("ConsultarDenuncia");
      return null;
    }

    if (caminho?.includes("minhas-denuncias")) {
      navigate("MinhasDenuncias");
      return null;
    }

    if (caminho?.includes("desativar-conta")) {
      navigate("DesativacaoConta");
      return null;
    }
  }
};

export const dadoExiste = (dado) => {
  if (typeof dado === "string") {
    const dadoValido =
      dado !== "" &&
      dado?.trim() !== "" &&
      dado?.toUpperCase() !== "NÃO INFORMADO" &&
      dado?.toUpperCase() !== "NAO INFORMADO" &&
      dado?.toUpperCase() !== "NI" &&
      dado?.toUpperCase() !== "NULL" &&
      dado?.toUpperCase() !== "R$ 0,00";

    if (dadoValido) return true;
    else return false;
  }
  if (dado !== undefined && dado != null) return true;
  return false;
};

export const inserirPontuacaoCpfCnpj = (value) => {
  if (!value) return value;
  const onlyNums = value.replace(/[^\d]/g, "");
  const eCpf = onlyNums?.length <= 11;
  let cpfCnpj = "";

  if (eCpf) {
    const term1 = onlyNums.slice(0, 3);
    const term2 = onlyNums.slice(3, 6);
    const term3 = onlyNums.slice(6, 9);
    const term4 = onlyNums.slice(9, 11);

    cpfCnpj = term1 ? term1 : "";

    cpfCnpj += term1.length === 3 && term2 ? "." : "";
    cpfCnpj += term2;
    cpfCnpj += term2.length === 3 && term3 ? "." : "";
    cpfCnpj += term3;
    cpfCnpj += term3.length === 3 && term4 ? "-" : "";
    cpfCnpj += term4;
    return cpfCnpj;
  }

  const term1 = onlyNums.slice(0, 2);
  const term2 = onlyNums.slice(2, 5);
  const term3 = onlyNums.slice(5, 8);
  const term4 = onlyNums.slice(8, 12);
  const term5 = onlyNums.slice(12, 14);

  cpfCnpj = term1 ? term1 : "";

  cpfCnpj += term1.length === 2 && term2 ? "." : "";
  cpfCnpj += term2;
  cpfCnpj += term2.length === 3 && term3 ? "." : "";
  cpfCnpj += term3;
  cpfCnpj += term3.length === 3 && term4 ? "/" : "";
  cpfCnpj += term4;
  cpfCnpj += term4.length === 4 && term5 ? "-" : "";
  cpfCnpj += term5;
  return cpfCnpj;
};

const validarCPF = (cpf) => {
  cpf = cpf.replace(/\D/g, "");

  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
    return "CPF inválido";
  }

  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) {
    resto = 0;
  }
  if (resto !== parseInt(cpf.charAt(9))) return "CPF inválido";

  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) {
    resto = 0;
  }
  if (resto !== parseInt(cpf.charAt(10))) return "CPF inválido";

  return null;
};

const validarCNPJ = (cnpj) => {
  const cnpjLimpo = cnpj.replace(/[^\d]+/g, "");
  const tamanhoCnpjValido = 14;
  const cnpjsInvalidosConhecidos = [
    "00000000000000",
    "11111111111111",
    "22222222222222",
    "33333333333333",
    "44444444444444",
    "55555555555555",
    "66666666666666",
    "77777777777777",
    "88888888888888",
    "99999999999999",
  ];

  if (cnpjLimpo.length !== tamanhoCnpjValido) {
    return "CNPJ inválido: CNPJ deve ter exatamente 14 dígitos!";
  }

  if (cnpjsInvalidosConhecidos.includes(cnpjLimpo)) {
    return "CNPJ inválido: CNPJ conhecido como inválido!";
  }

  let tamanho = cnpjLimpo.length - 2;
  let numeros = cnpjLimpo.substring(0, tamanho);
  let digitos = cnpjLimpo.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }

  const resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(0))) {
    return "CNPJ inválido: O primeiro dígito verificador não confere!";
  }

  tamanho = tamanho + 1;
  numeros = cnpjLimpo.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }

  if (soma % 11 < 2 ? 0 : 11 - (soma % 11) !== parseInt(digitos.charAt(1))) {
    return "CNPJ inválido: O segundo dígito verificador não confere!";
  }

  return null;
};

export const validarCPFouCNPJ = (cpfCnpj) => {
  if (!cpfCnpj || typeof cpfCnpj !== "string") {
    return "Digite um CPF/CNPJ válido";
  }

  cpfCnpj = cpfCnpj.replace(/\D/g, "");

  if (cpfCnpj.length === 11) {
    return validarCPF(cpfCnpj);
  } else if (cpfCnpj.length === 14) {
    return validarCNPJ(cpfCnpj);
  }

  return "Digite um CPF/CNPJ válido";
};

export const obterPrimeiroNome = (nomeCompleto, limite) => {
  const limiteCaracteres = limite || 15;
  const nomeTrim = dadoExiste(nomeCompleto) ? nomeCompleto.trim() : "Nome";
  const indiceEspaco = nomeTrim.indexOf(" ", 1);

  const nomeSimples = indiceEspaco === -1 || indiceEspaco <= limiteCaracteres;
  if (nomeSimples) return nomeTrim.slice(0, limiteCaracteres);

  const palavras = nomeTrim.split(" ");
  const primeiraPalavraEncontrada = palavras
    ?.find((palavra) => /[A-Z]/.test(palavra))
    ?.split(/(?=[A-Z])/)?.[0];

  if (primeiraPalavraEncontrada) {
    const indiceFinalPalavra =
      nomeTrim?.indexOf(primeiraPalavraEncontrada) +
      primeiraPalavraEncontrada.length;
    return nomeTrim?.slice(0, indiceFinalPalavra)?.slice(0, limiteCaracteres);
  }

  return nomeTrim?.slice(0, limiteCaracteres);
};

export const nomeSistemaLongo = eAplicativo
  ? `"Aplicativo Fiscalize Fortaleza"`
  : `"TOTEM - Denúncias"`;

export const nomeSistemaCurto = eAplicativo ? `"Aplicativo"` : `"TOTEM"`;
export const TEXTO_DESATIVACAO_CONTA = `Desativar a conta no ${nomeSistemaLongo} pode trazer consequências indesejadas. Ao manter a conta ativa, você preserva o acesso contínuo às funcionalidades de fiscalização e participação cidadã, o que pode ser extremamente valioso para você e para a comunidade em que vive.\n\nUma das principais vantagens de manter a conta ativa é a possibilidade de acompanhar as denúncias feitas por outros usuários. Isso permite que você fique informado sobre problemas e irregularidades que ocorrem em sua cidade, contribuindo para a transparência e a melhoria dos serviços públicos em Fortaleza.\n\nAlém disso, manter a conta no ${nomeSistemaCurto} significa que você pode continuar a fazer suas próprias denúncias, relatando questões que afetam diretamente sua qualidade de vida. Essa participação ativa é uma forma efetiva de exercer sua cidadania e contribuir para a construção de uma cidade mais justa e segura.\n\nAntes de desativar sua conta, é essencial refletir sobre as possíveis consequências. Pergunte-se se realmente deseja abrir mão do acesso a essa ferramenta valiosa de fiscalização e participação cidadã. Considere o impacto que sua decisão pode ter não apenas em sua própria capacidade de contribuir, mas também nas oportunidades que outros cidadãos terão de resolver problemas e promover mudanças positivas em Fortaleza.\n\nÉ importante destacar que, uma vez desativada, a recuperação da conta pode não ser possível ou pode requerer um processo burocrático. Portanto, é fundamental ter certeza de que você quer prosseguir com a desativação da sua conta no ${nomeSistemaCurto}.\n\nLembre-se de que sua participação é valiosa e faz diferença. O engajamento cidadão é fundamental para o fortalecimento da democracia e a construção de uma sociedade mais justa. Portanto, pense cuidadosamente antes de tomar uma decisão que possa limitar seu acesso a ferramentas que promovem o bem-estar coletivo e a qualidade de vida em sua cidade.`;

export const listaServicoComunitario = [
  { horaInicial: 1, horaFinal: 10, valor: 15.0 },
  { horaInicial: 11, horaFinal: 20, valor: 20.0 },
  { horaInicial: 21, horaFinal: 30, valor: 35.0 },
  { horaInicial: 31, horaFinal: 40, valor: 50.0 },
  { horaInicial: 41, valor: 30.0 },
];

export const tiposAutuados = [
  {
    descricao:
      "Pessoa física, inscrita no Cadastro Único (CadÚnico do Governo Federal)",
    valor: 1,
  },
  {
    descricao: "Pessoa física não declarante do imposto de renda",
    valor: 2,
  },
  {
    descricao: "Pessoa física declarante do imposto de renda",
    valor: 3,
  },
  {
    descricao: "Condomínio",
    valor: 4,
  },
  {
    descricao:
      "Fundação, Associação, partido político ou outra entidade sem fins lucrativos",
    valor: 5,
  },
  {
    descricao: "Igreja ou Templo Religioso",
    valor: 6,
  },
  {
    descricao: "Administração Pública Direta",
    valor: 7,
  },
  {
    descricao: "MEI - Microempreendedor Individual",
    valor: 8,
  },
  {
    descricao: "ME - Microempresa",
    valor: 9,
  },
  {
    descricao: "EPP - Empresa de Pequeno Porte",
    valor: 10,
  },
  {
    descricao:
      "Sociedade Anônima, Empresa Pública, Sociedade de Economia Mista",
    valor: 11,
  },
  {
    descricao:
      "Outra entidade empresarial que não se enquadra nas descrições anteriores",
    valor: 12,
  },
];

export const irParaFortalezaDigital = () => {
  const telaInicialAtual = localStorage.getItem(consts.TELA_INICIAL_KEY);
  window.location.href = `${consts.RHSSO_URL}/auth/realms/${consts.REALM_NAME}/protocol/openid-connect/auth?response_type=code&client_id=${consts.CLIENT_ID}&redirect_uri=${consts.URI}${telaInicialAtual}`;
};
